import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ModalModule} from 'ng2-bootstrap/modal';

import {ModalConfirmationComponent} from './modal-confirmation.component';

@NgModule({
  imports: [
    CommonModule,
    ModalModule.forRoot(),
  ],
  declarations: [
    ModalConfirmationComponent,
  ],
  exports: [
    ModalConfirmationComponent,
  ],
})
export class ModalConfirmationModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/shared/modals/modal-confirmation/modal-confirmation.module.ts